module.exports = __webpack_public_path__ + "img/bgBox_pc.207d8da2.jpg";